import { useState } from "react";
import { IntroCover } from "@/components/IntroCover";

// Anteprima dell'animazione finale reale. ?v=office per la palette Ufficio (lilla).
export default function IntroPreview() {
  const [k, setK] = useState(0);
  const variant = new URLSearchParams(window.location.search).get("v") === "office" ? "office" : "worker";
  return (
    <div className="min-h-screen bg-[#0f172a] relative">
      <IntroCover key={k} variant={variant} onDone={() => setTimeout(() => setK((v) => v + 1), 700)} />
      <button
        onClick={() => setK((v) => v + 1)}
        data-testid="intro-replay"
        className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[90] rounded-full bg-white/90 text-slate-800 text-sm font-semibold px-5 py-2 shadow-lg hover:bg-white"
      >
        Rigioca animazione
      </button>
    </div>
  );
}
